import { Material } from '@/colors/materials'
import { Perspective } from '@/types/Perspective'
import parts from '../colors/components'

class ComponentPictureLoader {
  static publicPath = process.env.BASE_URL

  static load(component: string, color: string, perspective: string, fileNameSuffix = "") {
    const fileName = this.getCorrectComponentFileName(component, color, perspective, fileNameSuffix)
    const correctedComponentNameForFolderStructure = this.getComponentNameForFolderStructure(component)
    const correctPerspective =
      perspective === Perspective.FRONT ? '20210628_tragwerk.T_Layers_vorne' : '20210628_tragwerk.T_Layers_hinten'
      return `https://kieserdesign.fra1.digitaloceanspaces.com/img/${correctPerspective}/20210628_${correctedComponentNameForFolderStructure}_${perspective}/${fileName}`
      // return require(`../assets/watch-components/${correctPerspective}/20210628_${correctedComponentNameForFolderStructure}_${perspective}/${fileName}`) // eslint-disable-line
  }

  static getCorrectComponentFileName(component: string, color: string, perspective: string, fileNameSuffix: string): string {
    if (perspective === Perspective.BACK && (component === parts.BAND_PART || component === parts.NAHT_PART)) {
      return `20210628_tragwerk.T_${perspective}_${component}_${color}${fileNameSuffix}.png`
    }
    return `20210628_tragwerk.T_${perspective}_${component}_${color}${fileNameSuffix}.png`
  }

  static getComponentNameForFolderStructure(component: string) {
    if (component === parts.BAND_PART) {
      return 'CorduraBand'
    }
    return component
  }

  static getFileSystemSuffixForMaterial(material: Material) {
    return material == Material.BRUSHED_MATERIAL ? '_gebuerstet' : ''
  }
}

export {ComponentPictureLoader}